
import validator from 'validator';

const ValidateJobpost = (data) => {
    let errors = {};

    const { mName, mContact,mEmail,cPIN,cAddr,jobSelect, jobRequirement,jobNopeople,responsibility,qualification, maxExp, minExp,wType, wPeriod,wdays,wrkHrfrm,wrkHrto,salary,pWorkHr,atitle, nPeriod,mnAge,mxAge,Noticesdt,Noticeedt } = data;
    // const emailRegex = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  
    if (validator.isEmpty(mName)) {
      errors.mName = "이 필드(관리자 이름)를 작성하십시오.";
    }
    if (validator.isEmpty(mContact)) {
      errors.mContact = "이 필드(관리자 연락처)를 작성하십시오.";
    }
    if (validator.isEmpty(mEmail)) {
      errors.mEmail = "이 필드(관리자 이메일)를 작성하십시오.";
    }
    // else if (!emailRegex.test(mEmail)) { 
    //   errors.mEmail = "올바른 이메일을 입력해주세요."; 
    // }
    if (validator.isEmpty(cPIN)) {
      errors.cPIN = "이 필드(PIN)를 작성하십시오.";
    }
    if (validator.isEmpty(cAddr)) {
      errors.cAddr = "이 필드(주소)를 작성하십시오.";
    }
    if (validator.isEmpty(mnAge)) {
      errors.mnAge = "이 필드(주소)를 작성하십시오.";
    }
    if (validator.isEmpty(mxAge)) {
      errors.mxAge = "이 필드(주소)를 작성하십시오.";
    }
    //talet Information
    if (validator.isEmpty(jobSelect)) {
        errors.jobSelect = "버튼을 클릭하여 작업을 선택하십시오.";
      }
      if (validator.isEmpty(jobRequirement)) {
        errors.jobRequirement = "이 필드를 작성하십시오.";
      }
      if (validator.isEmpty(jobNopeople)) {
        errors.jobNopeople = "이 필드를 작성하십시오.";
      }
      if (validator.isEmpty(responsibility)) {
        errors.responsibility = "이 필드를 작성하십시오 (책임).";
      }
      if (validator.isEmpty(minExp)) {
        errors.minExp = "이 필드를 작성하십시오.";
      }
      if (validator.isEmpty(maxExp)) {
        errors.maxExp = "이 필드를 작성하십시오.";
      }
      if (validator.isEmpty(Noticesdt)) {
        errors.Noticesdt = "이 필드를 작성하십시오.";
      }
      if (validator.isEmpty(Noticeedt)) {
        errors.Noticeedt = "이 필드를 작성하십시오.";
      }
      // if (carrer === 'experience' && regardlessAny !== true) {
      //   if (max_exper === null || min_exper === null) {
      //     errors.max_exper_min_exper = "이 필드를 작성하십시오.";
      //   }
      // }
      if (validator.isEmpty(qualification)) {
        errors.qualification = "이 필드를 작성하십시오 (자격).";
      }
      //working condition
      if (validator.isEmpty(wType)) {
        errors.wType = "근무 기간을 입력해 주세요.";
      }
      if (validator.isEmpty(wPeriod)) {
        errors.wPeriod = "근무 기간을 입력해 주세요.";
      }
      if (validator.isEmpty(wdays)) {
        errors.wdays = "요일을 선택해 주세요.";
      }
      if (validator.isEmpty(wrkHrfrm)) {
        errors.wrkHrfrm = "필수 입력 사항입니다.";
      }
      if (validator.isEmpty(wrkHrto)) {
        errors.wrkHrto = "필수 입력 사항입니다. ";
      }
      if (validator.isEmpty(salary)) {
        errors.salary = "필수 입력 사항입니다.";
      }
      if (validator.isEmpty(pWorkHr)) {
        errors.pWorkHr = "필수 입력 사항입니다.";
      }
      if (validator.isEmpty(atitle)) {
        errors.atitle = "공고 제목을 입력해 주세요.";
      }
      if (validator.isEmpty(nPeriod)) {
        errors.nPeriod = "공고 기간을 입력해 주세요.";
      }
    return {
        isInvalid: Object.keys(errors).length > 0,
        error: errors,
    };
};

export default ValidateJobpost;